import { render, staticRenderFns } from "./ModalMaterials.vue?vue&type=template&id=22b25a92&scoped=true"
import script from "./ModalMaterials.vue?vue&type=script&lang=js"
export * from "./ModalMaterials.vue?vue&type=script&lang=js"
import style0 from "./ModalMaterials.vue?vue&type=style&index=0&id=22b25a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b25a92",
  null
  
)

export default component.exports